import { render, staticRenderFns } from "./ScheduleEntryWidget.vue?vue&type=template&id=4e8fff96&scoped=true"
import script from "./ScheduleEntryWidget.vue?vue&type=script&lang=js"
export * from "./ScheduleEntryWidget.vue?vue&type=script&lang=js"
import style0 from "./ScheduleEntryWidget.vue?vue&type=style&index=0&id=4e8fff96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8fff96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
